export default {
  setHeaderTitle (state, data) {
    state.headerTitle = data
  },
  setClientHeight (state, data) {
    state.clientHeight = data
  },
  setPinKey (state, data) {
    state.pinKey = data
  },
  setMacKeyObj (state, data) {
    state.macKeyObj = data
  },
  setUser (state, data) {
    state.user = data
  },
  setSchCode (state, data) {
    state.schCode = data
  },
  setShowCleanSector (state, data) {
    state.showCleanSector = data
  },
  setSupportOutsideCard (state, data) {
    state.supportOutsideCard = data
  },
  setBizList (state, data) {
    state.lastBizList = state.bizList
    state.bizList = data
  },
  setLoginInfo (state, data) {
    state.loginInfo = data
  },
  setLastRequestFlag (state, data) {
    state.lastRequestFlag = data
  },
  setUserPrivileges (state, data) {
    state.userPrivileges = data
  },
  setInstImg (state, data) {
    state.instImg = data
  },
  setBasicDataStatusSorts (state, data) {
    state.basicDataStatusSorts = data
  },
  setPersonnelSorts (state, data) {
    state.personnelSorts = data
  },
  setPersonnelPostSorts (state, data) {
    state.personnelPostSorts = data
  },
  setMerchantList (state, data) {
    state.merchantList = data
  },
  setLicenseList (state, data) {
    state.licenseList = data
  },
  setProductList (state, data) {
    state.productList = data
  },
  setDeptList (state, data) {
    state.deptList = data
  },
  setDictTypeList (state, data) {
    state.dictTypeList = data
  },
  setMtDictTypeList (state, data) {
    state.mtDictTypeList = data
  },
  setDeviceFactoryList (state, data) {
    state.deviceFactoryList = data
  },
  setFactoryProductList (state, data) {
    state.factoryProductList = data
  },
  setProductModelList (state, data) {
    state.productModelList = data
  },
  setDeviceSorts (state, data) {
    state.deviceSorts = data
  },
  setPaymentTypeSorts (state, data) {
    state.paymentTypeSorts = data
  },
  setBatchStatusSorts (state, data) {
    state.batchStatusSorts = data
  },
  setOrderFoodPeriodTypeSorts (state, data) {
    state.orderFoodPeriodTypeSorts = data
  },
  clearDropDownList (state) {
    state.basicDataStatusSorts = []
    state.personnelSorts = []
    state.personnelPostSorts = []
    state.merchantList = []
    state.deptList = []
    state.productList = []
    state.dictTypeList = []
    // state.mtDictTypeList = []
    state.deviceFactoryList = []
    state.factoryProductList = []
    state.productModelList = []
    state.deviceSorts = []
    state.paymentTypeSorts = []
    state.orderFoodPeriodTypeSorts = []
    state.batchStatusSorts = []
  },
  // setPinkey (state, data) {
  //   state.pinkey = data
  // },
  // setMd5key (state, data) {
  //   state.md5key = data
  // },
  setTimestamp (state) {
    state.timestamp = new Date().getTime()
  },
  setUserId (state, data) {
    state.userId = data
  },
  setUserName (state, data) {
    state.userName = data
  },
  setPrivileges (state, data) {
    state.privileges = data
  },
  setBreadcrumb (state, data) {
    state.lastBreadcrumbContent = state.breadcrumbContent
    state.breadcrumbContent = data
  },
  setLoadCount (state, data) {
    data ? state.needLoadingRequestCount++ : state.needLoadingRequestCount === 0 ? state.needLoadingRequestCount = 0 : state.needLoadingRequestCount--
  },
  setDepartmentTree (state, data) {
    state.departmentTree = data
  },
  setAreaTree (state, data) {
    state.AreaTree = data
  },
  setPersonList (state, personList) {
    state.personList = personList
  },
  setSysParameterList (state, sysParameterList) {
    state.sysParameterList = sysParameterList
  },
  setInstitutionList (state, data) {
    state.institutionList = data
  },
  setUserList (state, data) {
    state.userList = data
  },
  setRoleList (state, data) {
    state.roleList = data
  },
  setDeviceList (state, data) {
    state.deviceList = data
  },
  setCommPassSettingList (state, data) {
    state.commPassSettingList = data
  },
  setRuleList (state, data) {
    state.ruleList = data
  },
  setDoorOpenList (state, data) {
    state.doorOpenList = data
  },
  setDoorList (state, data) {
    state.doorList = data
  },
  setHolidayList (state, data) {
    state.holidayList = data
  },
  setTempPassSettingList (state, data) {
    state.tempPassSettingList = data
  },
  setRuleId (state, data) {
    state.ruleId = data
  },
  setMenuList (state, data) {
    state.menuList = data
  },
  setHandleType (state, data) {
    state.ruleId = data
  },
  setDepartmentList (state, data) {
    state.departmentList = data
  },
  setPersonTypeList (state, data) {
    state.personTypeList = data
  },
  setStaffTypeList (state, data) {
    state.staffTypeList = data
  },
  setPassTypeList (state, data) {
    state.passTypeList = data
  },
  setDeviceTypeList (state, data) {
    state.deviceTypeList = data
  },
  setOpenModeList (state, data) {
    state.openModeList = data
  },
  setWarnTypeList (state, data) {
    state.warnTypeList = data
  },
  setCertTypeList (state, data) {
    state.certTypeList = data
  },
  setChooseDeviceList (state, data) {
    state.chooseDeviceList = data
  },
  clearPullDownList (state) {
    state.departmentList = []
    state.personTypeList = []
    state.staffTypeList = []
    state.passTypeList = []
    state.deviceTypeList = []
    state.openModeList = []
    state.warnTypeList = []
    state.certTypeList = []
    state.chooseDeviceList = []
  },
  clearPermission (state) {
    state.SystemPermission.isCheck = false
    state.InstitutionPermission.isCheck = false
    state.departmentPermission.isCheck = false
    state.UserPermission.isCheck = false
    state.RolePermission.isCheck = false
    state.LogPermission.isCheck = false
    state.deviceAreaPermission.isCheck = false
    state.personPermission.isCheck = false
    state.devicePermission.isCheck = false
    state.doorPermission.isCheck = false
    state.PassRulePermission.isCheck = false
    state.CommPassSettingPermission.isCheck = false
    state.TempPassSettingPermission.isCheck = false
    state.PassHistoryPermission.isCheck = false
    state.RealTimePassPermission.isCheck = false
  },
  setSystemPermission (state, data) {
    data.isCheck = true
    state.SystemPermission = data
  },
  setInstitutionPermission (state, data) {
    data.isCheck = true
    state.InstitutionPermission = data
  },
  setDepartmentPermission (state, data) {
    data.isCheck = true
    state.departmentPermission = data
  },
  setUserPermission (state, data) {
    data.isCheck = true
    state.UserPermission = data
  },
  setLogPermission (state, data) {
    data.isCheck = true
    state.LogPermission = data
  },
  setRolePermission (state, data) {
    data.isCheck = true
    state.RolePermission = data
  },
  setDeviceAreaPermission (state, data) {
    data.isCheck = true
    state.deviceAreaPermission = data
  },
  setPersonPermission (state, data) {
    data.isCheck = true
    state.personPermission = data
  },
  setDevicePermission (state, data) {
    data.isCheck = true
    state.devicePermission = data
  },
  setDoorPermission (state, data) {
    data.isCheck = true
    state.doorPermission = data
  },
  setPassRulePermission (state, data) {
    data.isCheck = true
    state.PassRulePermission = data
  },
  setCommPassSettingPermission (state, data) {
    data.isCheck = true
    state.CommPassSettingPermission = data
  },
  setTempPassSettingPermission (state, data) {
    data.isCheck = true
    state.TempPassSettingPermission = data
  },
  setHolidayPermission (state, data) {
    data.isCheck = true
    state.holidayPermission = data
  },
  setPassHistoryPermission (state, data) {
    data.isCheck = true
    state.PassHistoryPermission = data
  },
  setRealTimePassPermission (state, data) {
    data.isCheck = true
    state.RealTimePassPermission = data
  },
  setGroupOption (state, data) {
    data.isSet = true
    state.groupOption = data
  },
  setHideError (state, data) {
    state.hideError = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js